module.exports = __webpack_public_path__ + "img/Group 512 2.bfd93cea.png";